import styled from 'styled-components';

import { colorsV2 } from 'style/colors-v2';

export const SectionSeparator = styled.div`
  position: absolute;
  top: -32px;
  left: 0;
  border-top: 1px solid ${colorsV2.gray20};
  width: 100%;

  &::after {
    position: absolute;
    width: 4px;
    height: 4px;
    border-radius: 100%;
    background-color: ${colorsV2.gray100};
    left: calc(50% + 24px);
  }

  &::before {
    position: absolute;
    width: 4px;
    height: 4px;
    border-radius: 100%;
    background-color: ${colorsV2.gray100};
    left: calc(50% - 24px);
  }

  @media screen and (min-width: 768px) {
    top: -34px;

    width: 4px;
    height: 4px;
    border-radius: 100%;
    background-color: ${colorsV2.gray100};
    left: calc(50% - 2px);
    border-top: none;

    &::after {
      content: ' ';
    }

    &::before {
      content: ' ';
    }
  }

  @media screen and (min-width: 1366px) {
    width: 4px;
    height: 4px;
    border-radius: 100%;
    background-color: ${colorsV2.gray100};
    border-top: none;
    left: calc(370px - 2px);
  }
`;
